export default function CarrdPaste() {
  return (
    <li>
      <h3 id="add-widget">Add a Widget in Carrd builder</h3>
      <p>
        Go to the builder and click on <code>Add Element</code>. Then click on <code>Widget</code>.
        Change the type to <code>iFrame</code> and paste the URL you've copied in the previous step.
      </p>
      <p>
        If you want to learn more, here is the{' '}
        <a href="https://carrd.co/docs/building/embedding-iframes">documentation link</a> from
        Carrd.
      </p>
    </li>
  );
}
